import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Router} from "@angular/router";
import {Constants} from "../../constants";
import {environment} from "../../environments/environment";
import {formatDate} from "@angular/common";
import {AdminDocument} from "../../models/adminDocument";

@Injectable({
    providedIn: 'root'
})
export class AdminDocumentService {

    constructor(private http: HttpClient, private router: Router, @Inject(PLATFORM_ID) private platformId: any) {
    }

    getRequestHeaders() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem(Constants.LOCAL_TOKEN) ?? environment.publicApiToken,
        });
    }

    getFormDataRequestHeaders() {
        return new HttpHeaders({
            'Authorization': localStorage.getItem(Constants.LOCAL_TOKEN) ?? environment.publicApiToken
        });
    }

    getPublicRequestHeaders() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': environment.publicApiToken,
        });
    }

    async getAdminDocuments(companyId: string, requestedTo?: string) {
        let response: any;
        let params = {
            companyId: companyId,
            requestedTo: requestedTo ?? 'company'
        }

        try {
            response = await this.http.get(
                environment.apiUrl + '/adminDocuments',
                {
                    params,
                    headers: this.getRequestHeaders(),
                }).toPromise();
        } catch (e) {
            console.error('error getAdminDocuments: ', e)
        } finally {
            return response;
        }
    }

    async uploadAdminDocument(formData: FormData, documentType: string, companyId: string) {
        let response: any;
        let urlFile: string = '';
        try {
            response = await this.http.post(environment.apiUrl + '/adminDocuments/upload', formData, {headers: this.getFormDataRequestHeaders()}).toPromise();

            if (response.success) {
                urlFile = response.data;

                let responseSend: any = await this.http.post(environment.apiUrl + '/companyAdminDocuments/send',
                    {url: urlFile, adminDocumentId: documentType, companyId: companyId},
                    {headers: this.getRequestHeaders()})
                    .toPromise();

                return responseSend.success;
            }
        } catch (e) {
            console.error('error uploadAdminDocument: ', e)
        } finally {
            return response;
        }
    }

    async approveDocument( adminDocumentId: string, companyId: string ){
        let response: any

        try {
            response = await this.http.post(environment.apiUrl + '/companyAdminDocuments/approve', { adminDocumentId, companyId }, {headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error approveDocument: ', e);
        } finally {
          return response;
        }
    }

    async rejectDocument( adminDocumentId: string, companyId: string){
        let response: any

        try {
            response = await this.http.post(environment.apiUrl + '/companyAdminDocuments/reject', { adminDocumentId, companyId }, {headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error approveDocument: ', e);
        } finally {
            return response;
        }
    }

    async uploadAdminDocumentModel(adminDocument: AdminDocument){
        let response: any;

        try {
            response = await this.http.post(environment.apiUrl + '/adminDocuments', adminDocument, {headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error uploadAdminDocumentModel: ', e)
        } finally {
            return response;
        }
    }

    async updateCompanyDocumentModel(documentUpdated: AdminDocument) {
        let response: any;

        try {
            response = await this.http.put(environment.apiUrl + `/adminDocuments/${documentUpdated.id}`,documentUpdated,{headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error updateCompanyDocumentModel: ', e);
        } finally {
            return response;
        }
    }

    async deleteDocument(documentToDelete: AdminDocument) {
        let response: any;

        try {
            response = await this.http.delete(environment.apiUrl + `/adminDocuments/${documentToDelete.id}`,{headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error deleteDocument: ', e);
        } finally {
            return response;
        }
    }

    async uploadModelDocument(formData: FormData){
        let response: any;
        let urlFile: string = '';
        try {
            response = await this.http.post(environment.apiUrl + '/adminDocuments/upload', formData, {headers: this.getFormDataRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error uploadAdminDocumentModel: ', e)
        } finally {
            return response;
        }
    }
}
